import { useState, useEffect } from 'react';

import { toast } from 'react-toastify';
import { _PaymentFile } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { SelectProcessTypeConstants } from '../../../bpm/config/Componentes/SelectProcessTypeConstants';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { BasicButton } from '../../../theme/Component/BasicButton';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';



interface Props {
    onChange: any;
    label?: string;
    idValue?: number;
}

export const EditorPaymentFile = ({ idValue, onChange, label }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_PaymentFile);

    const [processType, setProcessType] = useState<number>();
    const [renderValue, setRenderValue] = useState<string>("");

    useEffect(() => {
        if (bean.IDPaymentFile != idValue && idValue) {
            instance.getPaymentFile(idValue).then(
                (resp) => {
                    if (resp.IDPaymentFile) {
                        setRenderValue(`${resp.Code} - ${resp.Name}`)
                    }
                }
            )
        }
    }, [idValue])

    const modal = useModal("Seleccione un Archivos de Pago de Cuentas por Pagar", MODAL_md)

    const getLista = () => {
        instance.getPaymentFileCatalogByProcessType(processType).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    const selectItem = () => {
        const selectedItem = lista.find(
            (item) => item?.DataBeanProperties?.IDPaymentFile == bean.IDPaymentFile
        );

        if (bean.IDPaymentFile) {
            setRenderValue(`${selectedItem.DataBeanProperties.Code}-${selectedItem.DataBeanProperties.Name}`)
            modal.close();
            onChange?.(selectedItem.DataBeanProperties)
        } else {
            toast.error("Valor no valido")
        }
    }

    const head = [
        { title: 'ID', property: 'IDPaymentFile', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
    ];


    return (
        <>
            <label>{label ? label : 'Archivo de Pago'}</label>
            <input
                type="text"
                className="form-control"
                placeholder="Buscar..."
                value={renderValue}
                onClick={() => { modal.open() }}
            />

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { selectItem() }}>
                <div className="row">
                    <div className="col-md-8">
                        <SelectProcessTypeConstants idSelector={processType} onChange={(e) => { setProcessType(e) }} lable='Tipo de Proceso' />
                    </div>
                    <div className="col-md-2">
                        <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                    </div>

                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} />
                    </div>
                </div>
            </Modal>
        </>
    )
}